module.exports = __webpack_public_path__ + "img/Background@2x.5de9589b.png";